import React, { useEffect, useState } from 'react'
import './styles.scss'
import Chart from 'components/Charts_Chart'
import { addDays, formatSwissDate } from 'components/Charts_Assets'
import MultiLine from 'components/Charts_MultiLine'
import { RangeSlider } from 'components/Hospitalisation/RangeSlider'

type drawDataType = []
export const Tests = ({}: {}) => {
  const [drawData, setDrawData] = useState<drawDataType | undefined>()

  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-TestsWeekly.json?a=123'
    )
      .then(response => response.json())
      .then(data => {
        console.log(data)
        setDrawData(data as drawDataType)
      })
  }, [])

  return (
    <div className='Tests'>
      <div className='left'>
        <Chart
          title='Anzahl Tests pro Woche'
          sub={
            // '7-Tage-Durchschnitt' +
            drawData
              ? 'bis ' + formatSwissDate(drawData[drawData.length - 1].d)
              : ''
          }
          source={
            <>
              Quelle:{' '}
              <a
                href='https://www.covid19.admin.ch/de/epidemiologic/test'
                target='_blank'
                rel='noreferrer'
              >
                BAG
              </a>
            </>
          }
        >
          <>
            {drawData && (
              <MultiLine
                data={[drawData.map(m => ({ d: m.d, v: m.num7 }))]}
                yDomain={[100000, 0]}
                xDomain={[new Date('2020-04-01'), addDays(120, new Date())]}
                yTicks={{
                  lines: [0, 50000, 100000],
                  text: [50000, 100000]
                }}
                height={300}
                xTicks={{
                  text: [
                    '2020-04-01',
                    '2021-01-01',
                    '2021-10-01'
                    // '2022-07-01'
                  ],
                  lines: [
                    '2020-04-01',
                    '2021-01-01',
                    '2021-10-01'
                    // '2022-07-01'
                  ]
                }}
                className='num7'
              />
            )}
          </>
        </Chart>
      </div>
      <div className='right'>
        <Chart
          title='Anteil positive Tests pro Woche'
          sub={
            'in %' +
            (drawData
              ? ', bis ' + formatSwissDate(drawData[drawData.length - 1].d)
              : '')
          }
          source={
            <>
              Quelle:{' '}
              <a
                href='https://www.covid19.admin.ch/de/epidemiologic/test'
                target='_blank'
                rel='noreferrer'
              >
                BAG
              </a>
            </>
          }
        >
          <>
            {drawData && (
              <MultiLine
                data={[drawData.map(m => ({ d: m.d, v: m.sharepos }))]}
                yDomain={[50, 0]}
                xDomain={[new Date('2020-04-01'), addDays(120, new Date())]}
                yTicks={{ lines: [0, 25, 50], text: [25, 50] }}
                height={300}
                xTicks={{
                  text: [
                    '2020-04-01',
                    '2021-01-01',
                    '2021-10-01'
                    // '2022-07-01'
                  ],
                  lines: [
                    '2020-04-01',
                    '2021-01-01',
                    '2021-10-01'
                    // '2022-07-01'
                  ]
                }}
                className='sharepos7'
                unit='%'
              />
            )}
          </>
        </Chart>
      </div>
    </div>
  )
}
